import * as React from 'react';
import { History } from 'history';
import ResetPasswordStore from '../stores/ResetPasswordStore';

export interface Props {
    history: History;
    match: {
        params: {
            token: string;
        };
    };
}

interface State {
    isValid: boolean;
    confirmPassword: string;
}

export default class ResetPasswordForm extends React.PureComponent<Props, State> {

    state: State;

    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            confirmPassword: '',
        };

        const { match: { params: { token } } } = props;
        ResetPasswordStore.resetToken = token;
    }

    render() {

        return (
            <div className="row">
                <div className="col-md-4 offset-md-4">
                    <form onSubmit={this._onSubmit} style={styles.form}>
                        <div className="form-group">
                            <label htmlFor="passwordInput">New Password</label>
                            <input
                                type="password"
                                className="form-control"
                                id="passwordInput"
                                placeholder="Enter your new password"
                                onChange={this._onPasswordChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="passwordInput">Confirm Password</label>
                            <input
                                type="password"
                                className="form-control"
                                id="confirmPasswordInput"
                                placeholder="Type your password again"
                                onChange={this._onConfirmPasswordChange}
                            />
                        </div>
                        <button type="submit" className="btn btn-primary">Set Password</button>
                    </form>
                </div>
            </div>
        );
    }

    _onPasswordChange = ({ target: { value } }) => {
        ResetPasswordStore.password = value;
    }

    _onConfirmPasswordChange = ({ target: { value } }) => {
        let newState = this.state;
        newState.confirmPassword = value;
        this.setState(newState);
    }

    _onSubmit = e => {
        if (this.state.confirmPassword !== ResetPasswordStore.password) {
            alert('Passwords do not match.');
            return;
        }

        e.preventDefault();
        const { history } = this.props;

        ResetPasswordStore.resetPassword()
        .then(() => {
            history.push('/reset_password_success');
        })
        .catch((error) => {
            // Show error and clear code
            alert(error.message);
        });
    }
}


const styles = {
    form: {
        marginTop: '5rem',
        padding: '2rem',
        border: '1px solid #eee',
        borderRadius: '10px',
    },
};



// WEBPACK FOOTER //
// ./src/components/ResetPasswordForm.tsx